import { onReady } from "@otto-ec/global-resources/dom"

export async function refreshSessionByOwt() {
    await fetch("/session-maintenance/refresh")
}

export function init() {
    onReady.subscribe(refreshSessionByOwt)
}
